import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveView from '../views/ResponsiveView';

import Radium from 'radium';


class BigButtonRound extends ResponsiveView {

  onViewResize(){
    return true;
  }

  onButtonClick(){
    if(this.props.onButtonClick) this.props.onButtonClick(this.props.id);
  }

  render() {
    return (
      <div style={this.styles().container} onClick={this.onButtonClick.bind(this)}>
        {this.props.label}
      </div>
    );
  }

  styles(){

    return {

      container:{
        textAlign:'center',
        background:this.props.background,
        color:this.props.labelColor,
        fontSize:'14px',
        fontWeight:'700',
        height:'48px',
        borderRadius:'24px',
        padding:'0 30px',
        lineHeight:'48px',
        display:'inline-block',
        cursor:'pointer',
        boxShadow:'0 1px 3px rgba(0,0,0,.3)',
        ':hover':{
          opacity:.8,
        }
      },



    }

  }
}

BigButtonRound.propTypes = {
  onButtonClick:PropTypes.func.isRequired,
  id:PropTypes.number,
  label:PropTypes.string,
  background:PropTypes.string,
  labelColor:PropTypes.string,
};

export default Radium(BigButtonRound);